export const tooltipTokens = {
  'tooltip-bg': 'var(--dp-color-text)',
  'tooltip-text': 'var(--dp-color-text-inverse)',
  'tooltip-font-size': 'var(--dp-font-size-sm)',
  'tooltip-padding': 'var(--dp-spacing-xs) var(--dp-spacing-sm)',
  'tooltip-border-radius': 'var(--dp-border-radius-sm)',
  'tooltip-max-width': '240px',
  'tooltip-z-index': '1100',
  'tooltip-arrow-size': '6px',
} as const;
